import {Injectable, Inject, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser} from "@angular/common";

@Injectable({
  providedIn: 'root'
})
export class SoundManagerService {

  public audioMessage:any;

  public audioEventStage:any;



  constructor(@Inject(PLATFORM_ID) private platformId: any) {
    if(isPlatformBrowser(this.platformId)){
      this.audioMessage = new Audio();
      this.audioMessage.src = "/assets/music/message.mp3";
      this.audioMessage.load();
      this.audioEventStage = new Audio();
      this.audioEventStage.src = "/assets/music/step.mp3";
      this.audioEventStage.load();
    }
  }
}
